// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1_rsO","title":"BackImages_title__18WuJ","images":"BackImages_images__1ruo6"};